var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_auth"},[_c('v-btn',{attrs:{"text":"","to":"/"}},[_vm._v("INICIO")]),_c('v-btn',{attrs:{"text":"","to":"/price"}},[_vm._v("Precios")]),_c('v-btn',{attrs:{"text":"","to":"/help"}},[_vm._v("ayuda")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }